<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت تامین کنندگان</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end justify-content-center">
        <div class="col-md-5">
          <label class="form-label fw-bold">عنوان</label>
          <VSelect
              v-model="newItem.title"
              :options="titles"
              label="title"
              placeholder="عنوان را انتخاب کنید"
              dir="rtl">
            <template v-slot:no-options>
              عنوان یافت نشد!
            </template>
          </VSelect>
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">نام و نام خانوادگی</label>
          <VSelect
              v-model="newItem.user"
              :options="users"
              label="full_name"
              placeholder="نام و نام خانوادگی را انتخاب کنید"
              dir="rtl"
              @update:modelValue="setSignature(newItem, newItem.user.signature)">
            <template v-slot:no-options>
              کاربر یافت نشد!
            </template>
          </VSelect>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
        <div class="col-md-8 mt-3 d-flex flex-column" v-if="newItem.user &&  newItem.user.signature">
          <label class="form-label fw-bold">امضای کاربر</label>
          <img class="img-fluid rounded" :src="newItem.user.signature" alt="امضای کاربر" title="امضای کاربر">
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['عنوان', 'نام و نام خانوادگی', 'آدرس امضای کاربر']"
          :fields="['title', 'full_name', 'signature_place']"
          :items="tableItems"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش تامین کننده"
          modal-id="supplierModalId"
          @save="updateItem"
      >
        <div class="row mb-3 justify-content-center">
          <div class="col-md-6">
            <label class="form-label fw-bold">عنوان</label>
            <VSelect
                v-if="editedItem"
                v-model="editedItem.title"
                :options="titles"
                label="title"
                placeholder="عنوان را انتخاب کنید"
                dir="rtl">
              <template v-slot:no-options>
                عنوان یافت نشد!
              </template>
            </VSelect>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">نام و نام خانوادگی</label>
            <VSelect
                v-if="editedItem"
                v-model="editedItem.user"
                :options="users"
                label="full_name"
                placeholder="نام و نام خانوادگی را انتخاب کنید"
                dir="rtl"
                @update:modelValue="setSignature(editedItem, editedItem.user.signature)">
              <template v-slot:no-options>
                کاربر یافت نشد!
              </template>
            </VSelect>
          </div>
          <div class="col-md-8 mt-3 d-flex flex-column" v-if="editedItem && editedItem.user && editedItem.user.signature">
            <label class="form-label fw-bold">امضای کاربر</label>
            <img class="img-fluid" :src="editedItem.user.signature" alt="امضای کاربر" title="امضای کاربر">
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import VSelect from "vue-select";

const baseStructure = {
  title: '',
  user: '',
  signature_place: '',
};

const toast = useToast();

export default {
  components: {VSelect, GeneralButton, GeneralTable, GeneralModal},

  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/suppliers/index',
      afterMutation: 'suppliers/setSuppliers'
    });

    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: 'suppliers/get-supplier-users',
      afterMutation: 'suppliers/setUsers'
    });
  },

  data() {
    return {
      newItem: structuredClone(baseStructure),
      titles: [
        'تهیه کننده',
        'سرپرست مستقیم',
        'مسئول آموزش',
        'رئیس منابع انسانی',
      ],
      editedItem: null,
      editIndex: null,
    };
  },

  computed: {
    suppliers: {
      get() {
        return this.$store.state.suppliers.suppliers;
      },
      set(value) {
        this.$store.commit('suppliers/setSuppliers', value);
      }
    },
    users: {
      get() {
        return this.$store.state.suppliers.users;
      }
    },
    tableItems: {
      get() {
        return this.suppliers.map(supplier => {
          supplier.full_name = supplier.user.full_name;
          supplier.signature_place = supplier.user.signature;
          return supplier;
        });
      }
    }
  },

  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: {
          title: this.newItem.title,
          supplier_id: this.newItem.user.id
        },
        endpoint: '/suppliers/store',
      });

      this.suppliers = [...this.suppliers, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },

    removeItem(index) {
      const supplier = this.suppliers.find((_, i) => i === index);
      this.suppliers = this.suppliers.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: supplier.id,
        endpoint: '/suppliers/delete',
      });
    },

    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('supplierModalId'));
      modal.show();
    },

    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.suppliers.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: {
          id: this.editedItem.id,
          title: this.editedItem.title,
          supplier_id: this.editedItem.user.id
        },
        endpoint: '/suppliers/update',
      });

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('supplierModalId'));
      modal.hide();
    },

    setSignature(item, signature) {
      item.signature_place = signature;
    },

    checkItemValidation(item) {
      if (!item.title || !item.user) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    }
  }
};
</script>
